<template>
  <div>
    <Sticky>
      <nav
        class="app-navbar"
        aria-label="Top navigation"
      >
        <div class="app-navbar__inner container-fluid">
          <button
            type="button"
            class="app-navbar__brand"
            @click="$router.push('/home')"
          >
            <!-- src="https://xn--nid4h0ai.com/assets/YANGON-SANDS-MOTION-2_4_(1)_1782368352028-MDZTxEl-.gif" -->
            <img
              class="app-navbar__logo"
              src="https://storage.googleapis.com/spacetech2/ys/logo1.avif"
              alt="Yangon Sands"
            >
          </button>

          <div class="app-navbar__actions">
            <div
              v-if="$route.path !== '/auth/login' && authUser"
              class="app-navbar__balance"
            >
              <img
                loading="lazy"
                class="app-navbar__coin"
                src="https://storage.googleapis.com/spacetech2/phoenix888/coin.png"
                alt=""
              >
              <span class="app-navbar__amount">
                {{ Number($store.state.authUser.amount).toLocaleString() }}
              </span>
              <span class="app-navbar__currency">MMK</span>
            </div>

            <button
              v-if="!authUser && isAndroid"
              type="button"
              class="app-navbar__icon-btn"
              aria-label="Download app"
              @click="appInstall()"
            >
              <img
                class="app-navbar__download-icon"
                src="https://storage.googleapis.com/spacetech2/phoenix888/smt233_download.png"
                alt=""
              >
            </button>

            <template v-if="!$store.state.authUser.phone">
              <button
                type="button"
                class="app-navbar__register-btn"
                @click="$router.push('/auth/register')"
              >
                {{ $t('auth.sign_up') }}
              </button>

              <button
                type="button"
                class="app-navbar__login-btn"
                @click="$router.push('/auth/login')"
              >
                {{ $t('auth.login') }}
              </button>
            </template>

            <div class="dropdown app-navbar__lang">
              <button
                type="button"
                class="app-navbar__lang-btn dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                aria-label="Change language"
              >
                <img
                  :src="$t('images.lang-img')"
                  alt=""
                  class="app-navbar__lang-flag"
                >
              </button>
              <div class="dropdown-menu dropdown-menu-right app-navbar__lang-menu">
                <a
                  class="dropdown-item app-navbar__lang-item"
                  @click="setLangLocalstorage('en')"
                >
                  <img
                    src="https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/united-kingdom.png"
                    alt=""
                  >
                  {{ $t('en') }}
                </a>
                <a
                  class="dropdown-item app-navbar__lang-item"
                  @click="setLangLocalstorage('mm')"
                >
                  <img
                    src="https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/myanmar.png"
                    alt=""
                  >
                  {{ $t('mm') }}
                </a>
                <a
                  class="dropdown-item app-navbar__lang-item"
                  @click="setLangLocalstorage('cn')"
                >
                  <img
                    src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/china.png"
                    alt=""
                  >
                  {{ $t('cn') }}
                </a>
                <a
                  class="dropdown-item app-navbar__lang-item"
                  @click="setLangLocalstorage('th')"
                >
                  <img
                    src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/thailand.png"
                    alt=""
                  >
                  {{ $t('th') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </Sticky>
  </div>
</template>
<script>
import { Toast, Dialog, Sticky } from 'vant';
import { mapActions } from 'vuex';

export default {
  components: { Sticky },
  data() {
    return {
      messages: [],
      showTop: false,
      isLogged: false,
      authUser: null,
      alreadyGranted: true,
    };
  },
  computed: {
    isAndroid() {
      return /android/i.test(navigator.userAgent);
    },
  },
  methods: {
    appInstall() {
      const userAgent = navigator.userAgent;

      if (/android/i.test(userAgent)) {
        window.location.href = 'https://6034876c5f22486e.africanbuffalo.site/Yangonsands.apk';
      }
      // else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      //   window.location.href = 'https://storage.googleapis.com/spacetech2/phoenix888/phoenix888.mobileconfig?ignoreCache=1';
      // } 
      else {
        alert('Unsupported device.');
      }
    },
    timeFormat(time) {
      return moment(time).startOf('hour').fromNow();
    },
    async getMessages() {
      try {
        const res = await axios.get('/messages');
        this.messages = res.data.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    showTopImage() {
      this.showTop = !this.showTop;
    },
    ...mapActions(['logoutUser', 'fetchUser']),
    askNotificationPermission() {
      Notification.requestPermission().then(async (permission) => {
        if (permission === 'granted') {
          this.alreadyGranted = false;
          alert(
            this.$store.state.language === 'en'
              ? 'Notification permission granted!'
              : 'အသိပေးချက်အတည်ပြုပြီးပြီ'
          );
        } else {
          alert(
            this.$store.state.language === 'en'
              ? 'Notification permission denied!'
              : 'အသိပေးချက်အတည်ပြုမပြီးပြီ'
          );
        }
      });
    },
    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure to log out?'
            : 'ထွက်မှာ သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မထွက်တော့ပါ',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
      })
        .then(async () => {
          await this.logoutUser();
          if (this.$route.path === '/home') {
            this.$router.go();
          } else {
            this.$router.push('/home');
            this.$router.go();
          }
          Toast.success(
            this.$store.state.language === 'en' ? 'Logged out!' : 'ထွက်ပြီးပြီ'
          );
        })
        .catch(() => { });
    },
    closeNavCollapse() {
      $('#navbar-default').collapse('hide');
    },
    setLangLocalstorage(language) {
      localStorage.setItem('language', language);
      this.$store.commit('setLanguage', language);
      this.$i18n.locale = language;
      $('#navbar-default').collapse('hide');
    },
    redirectLink(link) {
      this.$router.push(`/${link}`).catch(() => { });
      $('#navbar-default').collapse('hide');
    },
    redirectRoute(path) {
      if (path === '2d') {
        this.$router.push('/user/2d');
      } else {
        this.$router.push('/user/3d');
      }
      return true;
    },
  },
  async mounted() {
    this.authUser = await this.fetchUser();
    if (this.authUser) {
      this.isLogged = true;
    }
  }
};
</script>
<style scoped>
.app-navbar {
  position: relative;
  z-index: 20;
  background: rgba(8, 8, 8, 0.94);
  border-bottom: 1px solid var(--border-gold);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.app-navbar__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  min-height: 48px;
  padding: 0.35rem 0.65rem;
}

.app-navbar__brand {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.app-navbar__brand:active {
  opacity: 0.85;
}

.app-navbar__logo {
  height: 34px;
  width: auto;
  display: block;
}

.app-navbar__actions {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  min-width: 0;
}

.app-navbar__balance {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  max-width: 9.5rem;
  padding: 0.28rem 0.55rem;
  border-radius: 999px;
  background: rgba(207, 167, 87, 0.1);
  border: 1px solid rgba(207, 167, 87, 0.28);
}

.app-navbar__coin {
  flex-shrink: 0;
  height: 1.05rem;
  width: auto;
  animation: flip-coin 2.5s linear infinite;
  transform-style: preserve-3d;
}

.app-navbar__amount {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--text-gold);
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.app-navbar__currency {
  flex-shrink: 0;
  font-size: 0.62rem;
  font-weight: 600;
  color: var(--text-muted);
  line-height: 1;
}

.app-navbar__icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-card);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: border-color 0.2s ease, transform 0.15s ease;
}

.app-navbar__icon-btn:active {
  transform: scale(0.94);
}

.app-navbar__download-icon {
  width: 1.35rem;
  height: auto;
}

.app-navbar__register-btn {
  flex-shrink: 0;
  padding: 0.35rem 0.75rem;
  border: 1px solid rgba(207, 167, 87, 0.55);
  border-radius: 999px;
  background: transparent;
  color: var(--text-gold);
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: transform 0.15s ease, background 0.15s ease;
}

.app-navbar__register-btn:active {
  transform: scale(0.96);
}

.app-navbar__login-btn {
  flex-shrink: 0;
  padding: 0.35rem 0.85rem;
  border: none;
  border-radius: 999px;
  background: var(--gradient-primary);
  color: var(--color-on-primary);
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  box-shadow: 0 2px 10px rgba(207, 167, 87, 0.35);
  transition: transform 0.15s ease, box-shadow 0.2s ease;
}

.app-navbar__login-btn:active {
  transform: scale(0.96);
}

.app-navbar__lang {
  flex-shrink: 0;
}

.app-navbar__lang-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: 1px solid var(--border-color);
  border-radius: 50%;
  background: var(--bg-card);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: border-color 0.2s ease, transform 0.15s ease;
}

.app-navbar__lang-btn::after {
  display: none;
}

.app-navbar__lang-btn:active {
  transform: scale(0.94);
}

.app-navbar__lang-flag {
  width: 1.15rem;
  height: 1.15rem;
  border-radius: 50%;
  object-fit: cover;
}

.app-navbar__lang-menu {
  z-index: 1050;
  min-width: 8.5rem;
  margin-top: 0.35rem;
  padding: 0.35rem 0;
  border: 1px solid var(--border-gold);
  border-radius: 10px;
  background: var(--bg-elevated);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.55);
}

.app-navbar__lang-item {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.45rem 0.85rem;
  color: var(--text-primary);
  font-size: 0.82rem;
  cursor: pointer;
  transition: background 0.15s ease;
}

.app-navbar__lang-item:hover,
.app-navbar__lang-item:focus {
  background: rgba(207, 167, 87, 0.12);
  color: var(--text-gold);
}

.app-navbar__lang-item img {
  width: 1.15rem;
  height: 1.15rem;
  border-radius: 50%;
  object-fit: cover;
}

@keyframes flip-coin {
  0% {
    transform: rotateY(0deg);
  }

  50% {
    transform: rotateY(180deg);
  }

  100% {
    transform: rotateY(360deg);
  }
}

@media (min-width: 768px) {
  .app-navbar__inner {
    min-height: 52px;
    padding: 0.4rem 0.85rem;
  }

  .app-navbar__logo {
    height: 36px;
  }

  .app-navbar__balance {
    max-width: 11rem;
    padding: 0.32rem 0.65rem;
  }

  .app-navbar__amount {
    font-size: 0.82rem;
  }
}
</style>
